// TODO: replace with OrganisationType
export enum UserRole {
	OWNER = "owner",
	ADMIN = "admin",
	USER = "user"
}

export class Principal {
	readonly userId: number;
	readonly userEmail: string;
	readonly organisationId?: number;
	readonly userRole?: UserRole;
	readonly expiresAt: number;
	readonly signedEula: boolean;

	// TODO: take JWT
	constructor(
		userId: number,
		userEmail: string,
		organisationId: number | undefined,
		userRole: UserRole | undefined,
		expiresAt: number,
		signedEula: boolean
	) {
		this.userId = userId;
		this.userEmail = userEmail;
		this.organisationId = organisationId;
		this.userRole = userRole;
		this.expiresAt = expiresAt;
		this.signedEula = signedEula;
	}

	public isExpired(): boolean {
		return this.expiresAt < Date.now() / 1000;
	}

	public hasOrganisation(): boolean {
		return this.organisationId !== undefined;
	}

	public isPrivateOrganisation(): boolean {
		return this.organisationId !== undefined && this.organisationId !== 0;
	}

	// A user is allowed to access the app if he has a valid token
	// And if he accepted the eula.
	public isAllowedAccess(): boolean {
		return !this.isExpired() && this.signedEula;
	}

	// TODO: better naming.
	public isFullyAuthenticated(): boolean {
		if (this.isExpired()) {
			return false;
		}

		if (!this.hasOrganisation()) {
			return false;
		}

		if (!this.signedEula) {
			return false;
		}

		return true;
	}

	public isOwner(): boolean {
		return this.userRole == UserRole.OWNER;
	}

	public isAdmin(): boolean {
		return (
			this.userRole == UserRole.ADMIN || this.userRole == UserRole.OWNER
		);
	}
}
